/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What the pricing page shows, from the funnels the broker can access for the file's branch.
 * - classic: only comparable products (or no funnel at all), the comparator as it has always been.
 * - formulas: only fixed formulas, one card per product, no guarantee selection nor score.
 * - mixed: both, the comparator for the comparable products and the cards for the formulas.
 * 
 * @export
 */
export const PricingModeEnum = {
    Classic: 'classic',
    Formulas: 'formulas',
    Mixed: 'mixed'
} as const;
export type PricingModeEnum = typeof PricingModeEnum[keyof typeof PricingModeEnum];


export function instanceOfPricingModeEnum(value: any): boolean {
    for (const key in PricingModeEnum) {
        if (Object.prototype.hasOwnProperty.call(PricingModeEnum, key)) {
            if (PricingModeEnum[key as keyof typeof PricingModeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PricingModeEnumFromJSON(json: any): PricingModeEnum {
    return PricingModeEnumFromJSONTyped(json, false);
}

export function PricingModeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingModeEnum {
    return json as PricingModeEnum;
}

export function PricingModeEnumToJSON(value?: PricingModeEnum | null): any {
    return value as any;
}

export function PricingModeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PricingModeEnum {
    return value as PricingModeEnum;
}

